import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';
import { ClipboardIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

export default function CompanyKeyCard({ organizationId }) {
  const [organizationKey, setOrganizationKey] = useState('');
  const [userRole, setUserRole] = useState('');
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchKeyAndRole = async () => {
      if (!organizationId) return;
      try {
        setLoading(true);

        // ✅ FIX: Use `getUser()` instead of `supabase.auth.user()`
        const { data: userData, error: userError } = await supabase.auth.getUser();
        if (userError || !userData?.user) {
          console.error('Error fetching user:', userError);
          return;
        }

        const userId = userData.user.id;

        // Fetch user role
        const { data: roleData, error: roleError } = await supabase
          .from('organization_members')
          .select('role')
          .eq('organization_id', organizationId)
          .eq('user_id', userId)
          .single();

        if (roleError || !roleData) {
          console.error('Error fetching user role:', roleError);
          return;
        }

        setUserRole(roleData.role);

        // Fetch organization key if user is an admin/owner
        if (roleData.role === 'admin' || roleData.role === 'owner') {
          const { data: orgData, error: orgError } = await supabase
            .from('organizations')
            .select('organization_key')
            .eq('id', organizationId)
            .single();

          if (orgError || !orgData) {
            console.error('Error fetching organization key:', orgError);
            return;
          }

          setOrganizationKey(orgData.organization_key);
        }
      } catch (err) {
        console.error('Unexpected error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchKeyAndRole();
  }, [organizationId]);

  const handleCopyKey = () => {
    navigator.clipboard.writeText(organizationKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (loading) {
    return <div></div>;
  }

  if (userRole !== 'admin' && userRole !== 'owner') {
    return null; // Hide card for non-admins
  }

  return (
    <div className="p-4 my-4 rounded-lg bg-gray-50 border border-gray-300 shadow-sm">
      <h3 className="text-lg font-semibold text-gray-700">Company Key</h3>
      <p className="mb-2 text-sm">Send this code to team members so they can join your organization through the mobile app.</p>
      <div className="relative flex items-center">
        <input
          type="password"
          value="************"
          readOnly
          className="w-full px-3 py-2 rounded-md border border-gray-300 shadow-sm text-gray-700 bg-gray-100 focus:border-yellow-500 focus:ring-yellow-500"
        />
        <button
          onClick={handleCopyKey}
          className="absolute right-3 text-gray-600 hover:text-gray-800"
        >
          <ClipboardIcon className="w-5 h-5" />
        </button>
      </div>
      {copied && <p className="text-green-600 text-sm mt-2">Copied to clipboard!</p>}
    </div>
  );
}
